import defaults from "./defaults";
import Tests from "./Tests";
import HealthSafety from "./HealthSafety";
import Request from "./Request";
import Tenants from "./Tenants";
import Authenticate from "./Authenticate";
import utils from "./utils";

/**
 * The main entry point for the NucleusXP SDK.
 * Manages tenants, authentication, requests, and various modules.
 */
class NucleusXP {

  /**
   * Creates an instance of the `NucleusXP` class.
   * Initializes tenants, authentication, requests, and other modules.
   */
  constructor() {

    /**
     * @property {Tenants} tenants - Manages tenant data and current tenant selection.
     */
    this.tenants = new Tenants(
      defaults.tenants || [],
      defaults.currentTenantIndex || 0
    );

    // Initialize authentication
    const auth = new Authenticate(this.tenants);
    this.isAuthenticated = auth.isAuthenticated.bind(auth);
    this.authenticate = auth.authenticate.bind(auth);
    this.logout = auth.logout.bind(auth);

    // Initialize request handler
    const request = new Request(auth, this.tenants);
    this.request = request.request.bind(request);

    /**
     * @property {HealthSafety} healthSafety - Manages health and safety-related functionality.
     */
    this.healthSafety = new HealthSafety(request);

    /**
     * @property {Tests} tests - Manages test-related functionality.
     * Depends on `Request`, `Tenants`, and `HealthSafety`.
     */
    this.tests = new Tests(
      request,
      this.tenants,
      this.healthSafety
    );
  }
}

// Expose the `NucleusXP` instance globally and initialize
const nucleusxp = window.nucleusxp = new NucleusXP();

utils.log('Initialized ...');

export default nucleusxp;